"use strict";
exports.__esModule = true;
var formErrorsActions_1 = require("./formErrorsActions");
var wikom_data_1 = require("@wikom/wikom-data");
var runningCheck = {};
var checkData = function (_a) {
    var name = _a.name, url = _a.url;
    return function (values, dispatch) {
        if (runningCheck[name]) {
            runningCheck[name].cancel();
        }
        var req = wikom_data_1.actions.post({ url: url, data: values });
        runningCheck[name] = req
            .then(function (result) {
            dispatch((0, formErrorsActions_1.setFormErrors)(name, result.body.data));
            delete runningCheck[name];
        });
        runningCheck[name].cancel = function () { return req.abort(); };
        return runningCheck[name];
    };
};
exports["default"] = checkData;
